import { PROCESS } from "@/data/content";
import { Reveal } from "./Reveal";

export const Process = () => (
  <section id="process" className="relative py-28 md:py-40" data-testid="process">
    <div className="ec-container">
      <Reveal>
        <p className="ec-eyebrow mb-4">
          <span className="h-1.5 w-1.5 rounded-full bg-[#D4F870]" />
          MANIFESTO / SÜREÇ
        </p>
        <h2 className="max-w-3xl font-display text-4xl leading-[1.02] tracking-tight text-[#F3F4F6] sm:text-5xl md:text-6xl">
          Üç adımda denetlenebilir karbon raporu.
        </h2>
      </Reveal>

      <div className="mt-20 flex flex-col divide-y divide-white/10 border-t border-white/10">
        {PROCESS.map((p, i) => (
          <Reveal key={p.no} delay={i * 0.08}>
            <div className="group grid grid-cols-1 gap-6 py-12 transition-colors md:grid-cols-12 md:items-baseline">
              <div className="md:col-span-3">
                <span
                  className="font-display text-6xl leading-none text-transparent transition-all duration-500 group-hover:text-[#D4F870] md:text-8xl"
                  style={{ WebkitTextStroke: "1px rgba(243,244,246,0.30)" }}
                >
                  {p.no}
                </span>
              </div>
              <h3 className="font-display text-3xl text-[#F3F4F6] md:col-span-3 md:text-4xl">
                {p.title}
              </h3>
              <p className="max-w-xl text-base leading-relaxed text-[#9CA3AF] md:col-span-6">
                {p.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
